export default {
  name: "SuperAdmin"
};